export const setSessionStorageData = (key: string, payload: string) => {
    sessionStorage.setItem(key, payload);
};
export const getSessionStorageData = (key: string): string => {
    return sessionStorage.getItem(key) || '';
};
export const deleteSessionStorageData = (key: string) => {
    return sessionStorage.removeItem(key);
};
